export enum HtmlLocale {
  NO = 'nb-NO',
  EN = 'en-US',
  UA = 'uk-UA',
}

export enum LanguageLocale {
  NORWEGIAN = 'no',
  EN = 'en',
  UA = 'uk',
  NEW_NORGEWIAN = 'nn',
  NORWEGIAN_BOKMAL = 'nb',
}

export enum AppLanguage {
  EN = 'en',
  NO = 'no',
  UA = 'uk',
}

// Open Graph locale codes (underscore-separated, per the OG spec) — distinct from
// HtmlLocale's BCP-47 hyphenated codes. Used for og:locale / og:locale:alternate.
export enum OgLocale {
  EN = 'en_US',
  NO = 'nb_NO',
  UA = 'uk_UA',
}

export const OG_LOCALE_BY_LANGUAGE: Record<AppLanguage, OgLocale> = {
  [AppLanguage.EN]: OgLocale.EN,
  [AppLanguage.NO]: OgLocale.NO,
  [AppLanguage.UA]: OgLocale.UA,
}

export enum NORWEGIAN_LANGUAGE_LOCALES {
  NO = 'no',
  NB = 'nb',
  NN = 'nn',
}

export enum IpApiCountryCode {
  NORWAY = 'NO',
}
